import PageLoader from '@/app/common/components/PageLoader/PageLoader'
import { useNavigate, useParams } from 'react-router-dom'
import { ItemDetailUI } from '../../components/ItemDetailUI'
import { useMarketplacePreviewData } from '../hooks/useMarketplacePreviewData'

export function MarketplacePreviewItemDetailsPage() {
  const { itemsQuery } = useMarketplacePreviewData()
  const navigate = useNavigate()

  const { itemId } = useParams()

  return (
    <PageLoader query={itemsQuery}>
      {(data) => {
        if (!itemId) {
          throw new Error('Item ID is required')
        }

        const selectedItem = data.data.find(
          (item) => item.id === parseInt(itemId)
        )

        if (!selectedItem) {
          throw new Error('Item not found')
        }

        return (
          <ItemDetailUI
            data={selectedItem}
            onGoBack={() => navigate(-1)}
            onAddToCart={() => {}}
            buttonAnimated={false}
          />
        )
      }}
    </PageLoader>
  )
}
